export default {
    setEnabled: {
        success: 'Status successfully changed',
        error: 'Error while changing the status'
    },
    inviteUsers: {
        success: 'Participants successfully invited',
        autoEnabled: 'The internal evaluation has been successfully activated.',
        error: 'Error while inviting new participants'
    },
    uninviteUser: {
        success: 'Participant successfully removed',
        error: 'Error while removing a participant'
    },
    removeParticipants: {
        success: 'All participants successfully removed',
        error: 'Error while removing the participants'
    },
    sendMessage: {
        success: 'Message successfully sent',
        error: 'Message could not be sent'
    }
}
